/* c8 ignore start */
import { DEV_ENV, DevEnv, Environment } from '@root/env/environment';

function _isDevMode(env: Environment): env is DevEnv {
  return env in DEV_ENV;
}
export const currentEnvironment = import.meta.env.MODE as Environment;
export const isDevMode = _isDevMode(currentEnvironment);
/* c8 ignore stop */
